module.exports = __webpack_public_path__ + "static/media/Giuseppe-oval.19977ccb.jpg";